export const openNewWindow = (link: string) => {
  setTimeout(() => {
    window.open(link, '_blank')
  })
}

